var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import * as React from "react";
import { Icon } from "sb-resp-ui";
import { EventCardIcon } from "../../EventCardIcon";
import { createEmptyTooltipIcon } from "./createEmptyTooltipIcon";
export var renderPulseBetIcon = function (hasPulseBet, pulseBetTooltip) {
    var props = {
        className: "rj-ev-list__ev-card-icon--tooltip",
        tooltip: pulseBetTooltip
    };
    return (hasPulseBet
        ? React.createElement(EventCardIcon, __assign({}, props),
            React.createElement(Icon, { i: "i-24-16 i-o-ev-pulse" }))
        : createEmptyTooltipIcon());
};
//# sourceMappingURL=renderPulseBetIcon.js.map